import * as React from 'react'

import { cn } from '@/lib/utils'

export interface ChecklistProps {
  items: React.ReactNode[]
  /** Defaults to a check glyph at 3px stroke — pass to override. */
  icon?: React.ReactNode
  className?: string
}

const DEFAULT_CHECK = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3}>
    <path d="m5 12 4 4 10-10" />
  </svg>
)

/**
 * Feature checklist. The checkmark is never wrapped in a tinted circle —
 * render it bare, colored brand-600 (safety-green-600), at 16×16.
 */
export function Checklist({ items, icon = DEFAULT_CHECK, className }: ChecklistProps) {
  return (
    <ul className={cn('grid list-none gap-4 p-0', className)}>
      {items.map((item, i) => (
        <li key={i} className="text-md text-ink-600 flex items-start gap-2 leading-normal">
          <span className="text-brand-600 mt-[3px] flex-none [&_svg]:size-4" aria-hidden="true">
            {icon}
          </span>
          {item}
        </li>
      ))}
    </ul>
  )
}
